import { render, staticRenderFns } from "./AIAssessment_v2.vue?vue&type=template&id=6e4d474f&scoped=true&"
import script from "./AIAssessment_v2.vue?vue&type=script&lang=js&"
export * from "./AIAssessment_v2.vue?vue&type=script&lang=js&"
import style0 from "./AIAssessment_v2.vue?vue&type=style&index=0&id=6e4d474f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4d474f",
  null
  
)

export default component.exports